import { useQuery } from '@tanstack/vue-query'
import type { ComputedRef } from 'vue'
import { computed } from 'vue'

import {
  getSessionObjectivesWithProgress,
  SESSION_OBJECTIVES_QUERY_KEY,
} from '@/features/programs/api/session-objectives.api'

/**
 * Hook pour récupérer et transformer les données spécifiques au dashboard
 */
function useDashboardData({
  selectedGroupIdRef,
}: {
  selectedGroupIdRef: ComputedRef<string | null>
}) {
  // Fetch objectives with progress for selected group
  const { data: objectivesData, isPending: isPendingObjectivesRef } = useQuery({
    queryKey: [SESSION_OBJECTIVES_QUERY_KEY, 'progress', 'group', selectedGroupIdRef],
    queryFn: () => {
      if (!selectedGroupIdRef.value)
        return Promise.resolve({ objectives: [], hasMessages: false, conversationId: '' })
      return getSessionObjectivesWithProgress(selectedGroupIdRef.value)
    },
    enabled: computed(() => !!selectedGroupIdRef.value),
  })

  const objectivesRef = computed(() => objectivesData.value?.objectives || [])
  const hasMessagesRef = computed(() => objectivesData.value?.hasMessages || false)
  const conversationIdRef = computed(() => objectivesData.value?.conversationId || null)

  return {
    objectivesRef,
    hasMessagesRef,
    conversationIdRef,
    isPendingObjectivesRef,
  }
}

export default useDashboardData
